import { useEffect, useRef } from 'react';
export function useIntersection(cb, opts) {
    const ref = useRef(null);
    useEffect(() => {
        if (!ref.current)
            return;
        const io = new IntersectionObserver(cb, opts);
        io.observe(ref.current);
        return () => io.disconnect();
    }, [cb, opts]);
    return ref;
}
//# sourceMappingURL=useIntersection.js.map